import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, Button } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useOrder } from '../context';
import { OrderDeliver } from '../components/OrderForm/OrderDeliver';

export default function OrderDeliverPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { setOrderId, orderData, isDataLoading } = useOrder();

  useEffect(() => {
    if (id) setOrderId(id);
  }, [id, setOrderId]);

  if (isDataLoading) return <div>Carregando...</div>;
  if (!orderData) return <div>Encomenda não encontrada</div>;

  return (
    <Box sx={{ p: { xs: 1, md: 4 }, background: '#F6F8FB', minHeight: '100vh' }}>
      <Box maxWidth={600} mx="auto">
        <Paper sx={{ p: { xs: 2, md: 4 }, borderRadius: 4, boxShadow: '0 2px 12px 0 rgba(16,30,54,0.06)' }}>
          <Box display="flex" alignItems="center" gap={1} mb={3}>
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate(`/orders/${id}`)}
              sx={{ mr: 2 }}
            >
              Voltar
            </Button>
            <Typography fontWeight={700} fontSize={20} color="text.primary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <LocalShippingIcon sx={{ color: 'primary.main', fontSize: 22 }} />
              Entregar ou Retirar Encomenda
            </Typography>
          </Box>
          <Typography color="text.secondary" mb={3}>
            Escolha uma das opções abaixo para entregar ou retirar a encomenda <b>{orderData.orderCode}</b>.
          </Typography>
          <OrderDeliver orderId={orderData.id} />
        </Paper>
      </Box>
    </Box>
  );
}